export default __webpack_public_path__ + "static/media/CollapserIcon.9afe7a33.svg";